import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { TitleHeader } from 'web-library';
import { AUTHORITY_NAMES } from 'web-library/models/AuthorityFunctions';
import { useGetUserAuthorities } from '../../api-refactored/user/useGetUserAuthorities';
import LoadingComponent from '../../components/LoadingComponent';
import NonNationalReportDetails from '../../modules/admin/components/RegistrationReport/NonNationalReportDetails';
import RouteKey from '../../routes/key';

const { error } = RouteKey.child;
const { generic } = RouteKey.error.child;

const NonNationalRegistrationReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [hasView, setHasView] = useState<boolean>(false);

  const { data: userAuthoritiesData = [], isLoading: isLoadingAuthorities } =
    useGetUserAuthorities();

  useEffect(() => {
    if (isLoadingAuthorities) {
      setHasView(false);
    } else if (
      !isLoadingAuthorities &&
      !userAuthoritiesData?.includes(AUTHORITY_NAMES.CP_ADMIN_NON_NATIONAL_REGISTRATION_REPORT_VIEW)
    ) {
      setHasView(false);
      history.push(`/${error}/${generic}`);
    } else {
      setHasView(true);
    }
  }, [history, userAuthoritiesData, isLoadingAuthorities]);

  return (
    <>
      <TitleHeader title={t('admin->RegistrationReport.Registration Report')} />
      {!isLoadingAuthorities && hasView ? <NonNationalReportDetails /> : <LoadingComponent />}
    </>
  );
};

export default NonNationalRegistrationReport;
